import { render, staticRenderFns } from "./QuestionnairePage.vue?vue&type=template&id=35e89688&"
import script from "./QuestionnairePage.vue?vue&type=script&lang=js&"
export * from "./QuestionnairePage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnairePage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports